
import { ReactNode } from 'react';
import CustomSidebar from '@/components/dashboard/CustomSidebar';
import Header from '@/components/dashboard/Header';
import TrialFooter from '@/components/dashboard/TrialFooter';
import AnnouncementBanner from '@/components/dashboard/AnnouncementBanner';
import { DashboardActivityTracker } from './DashboardActivityTracker';

interface DashboardLayoutProps {
  children: ReactNode;
  userName: string;
  activePage: string;
  setActivePage: (page: string) => void;
  handleSignOut: () => Promise<void>;
  handleInviteUser: () => void;
  isTrialActive?: boolean;
  daysRemaining?: number | null;
}

const DashboardLayout = ({
  children,
  userName,
  activePage,
  setActivePage,
  handleSignOut,
  handleInviteUser,
  isTrialActive = false,
  daysRemaining = null,
}: DashboardLayoutProps) => {
  return (
    <>
      <DashboardActivityTracker />
      <div className="flex flex-col h-screen bg-pastel-blue-light dark:bg-[#121624] text-gray-900 dark:text-gray-100 transition-colors dashboard-layout">
        {/* Announcement Banner */}
        <AnnouncementBanner />
        
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <CustomSidebar 
            userName={userName} 
            activePage={activePage} 
            setActivePage={setActivePage} 
            handleSignOut={handleSignOut} 
            handleInviteUser={handleInviteUser} 
          />
          
          {/* Main content */}
          <div className="flex-1 flex flex-col overflow-hidden">
            {/* Header */}
            <Header 
              activePage={activePage} 
              handleInviteUser={handleInviteUser} 
            />
            
            {/* Page content */}
            <main className="flex-1 overflow-y-auto p-6 bg-pastel-blue-light dark:bg-[#121624] transition-colors">
              {children}
            </main>
            
            {/* Trial footer - conditional display */}
            {isTrialActive && daysRemaining !== null && (
              <TrialFooter 
                daysRemaining={daysRemaining} 
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
